import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';
import { viewEnginePiletOverlays } from '@sharefiledev/view-engine-pilet-sdk';
import { BlockNames } from '../block.types';

const LazyViewByContainerRID = React.lazy(
	() => import('../components/ViewByContainerRID')
);

const defaultFallbackView = {
	blocks: [
		{
			blockRID: '',
			blockName: BlockNames.Text,
			blockParameters: {
				text: {
					en: 'View does not exist',
				},
			},
		},
	],
	rid: '',
	name: 'no-view',
	rootBlockRID: '',
};

export const ViewByContainerRIDDrawer: React.FC<
	OverlayDrawerComponentProps<typeof viewEnginePiletOverlays.viewByContainerRIDDrawer>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options?.containerRID) {
		return <div data-testid="drawer-view-by-container-rid-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-drawer-view-by-container-rid" />}>
			<LazyViewByContainerRID
				containerRID={options.containerRID}
				cancelInteraction={cancelInteraction}
				completeInteraction={completeInteraction}
				piletApi={piral}
				fallbackView={options.fallbackView ?? defaultFallbackView}
				contractData={options.contractData}
			/>
		</React.Suspense>
	);
};
